import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  min-width: 500px;
  max-width: 600px;
  max-height: 70vh;
  color: #333;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  
  * {
    color: inherit;
  }
`;

export const SearchContainer = styled.div`
  margin-bottom: 15px;
`;

export const ResultsList = styled.div`
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-top: 10px;
`;

export const ResultItem = styled.div`
  padding: 12px 15px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #f5f5f5;
  }
  
  &:last-child {
    border-bottom: none;
  }
`;

export const LoadingContainer = styled.div`
  padding: 40px;
  text-align: center;
  color: #666;
  font-size: 14px;
`;

export const EmptyMessage = styled.div`
  padding: 40px;
  text-align: center;
  color: #999;
  font-size: 14px;
  font-style: italic;
`;

